module.exports = __webpack_public_path__ + "media/images/playbook_careers_page-4fdadee5b59c2390ba9f8aa9e0f82424.svg";